/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

export type AnswerOptionIcon = typeof AnswerOptionIcon[keyof typeof AnswerOptionIcon];


export const AnswerOptionIcon = {
  green: 'green',
  orange: 'orange',
  red: 'red',
  arrow_up_right: 'arrow_up_right',
  arrow_right: 'arrow_right',
  arrow_back_left: 'arrow_back_left',
  arrow_back_left_alt: 'arrow_back_left_alt',
  thumbs_up: 'thumbs_up',
  thumbs_down: 'thumbs_down',
} as const;
